import { useMutation } from '@apollo/client';
import UPDATE_EPUB_ANNOTATION from 'graphql/mutations/epubAnnotations/UpdateEpubAnnotation.graphql';

export default function useUpdateEpubAnnotationMutation() {
  return useMutation(UPDATE_EPUB_ANNOTATION);
}
